import { useEffect, useState } from 'react';
import classes from './TextQuestion.module.scss';
import { useGameSounds, useMediaQuery } from '@educaplay/core';
import InputTopWithButtons from '../InputTopWithButtons';
import { motion } from 'framer-motion';
import useSlice from '../../../../hooks/useSlice';
import { GAMEMODE, VIDEOQUIZ_SOUNDS, VIEW_COUNT_DURATION } from '../../../../utils/constants';
import useVideoQuizConfig from '../../../../hooks/useVideoQuizConfig';
import IframeInput from './IframeInput';
import NormalInput from './NormalInput';
import useVideo from '../../../../hooks/useVideo';

export function TextQuestion(props) {

    const { onAnswer, onClick, previousAnswers } = props;
    const [inputValue, setInputValue] = useState(previousAnswers == null ? '' : previousAnswers);
    const [hasAnswered, setHasAnswered] = useState(false);
    const { markQuestionViewed, currentQuestionTimeAppear } = useSlice();
    const { progress } = useVideo();
    const isInputEmpty = inputValue?.trim().length === 0;
    const isTouchDevice = (useMediaQuery("(hover:none)") || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0));
    const maxwidthMediaQuery = useMediaQuery("(max-width: 1025px)");
    const inputDisabled = previousAnswers != null;
    const canPassQuestion = hasAnswered && previousAnswers == null;
    const { gameMode } = useVideoQuizConfig();
    const gameSound = useGameSounds();

    useEffect(() => {
        if (progress !== currentQuestionTimeAppear || previousAnswers === null) return;
        const timeId = setTimeout(() => {
            markQuestionViewed();
        }, gameMode === GAMEMODE.FREEDOM ? VIEW_COUNT_DURATION : 0)

        return () => {
            clearTimeout(timeId)
        }
    }, [markQuestionViewed, gameMode, progress, currentQuestionTimeAppear, previousAnswers])


    const onChangeHandler = (ev) => {
        setInputValue(ev.target.value);
    }

    const onSubmitHandler = (ev) => {
        ev.preventDefault();
        if (hasAnswered) return;
        gameSound.play(VIDEOQUIZ_SOUNDS.SUBMIT);

        setHasAnswered(true);
        onAnswer(ev.target.options.value.trim());
    }

    const soundInputHandler = (event) => {
        if (event.key === 'Backspace' && !isTouchDevice && !isInputEmpty) {
            gameSound.play(VIDEOQUIZ_SOUNDS.DELETE);
        }

        if (event.key !== 'Backspace' && event.key !== 'Shift' && !isTouchDevice) {
            gameSound.play(VIDEOQUIZ_SOUNDS.WRITE);
        }
    }

    return (
        <>
            {isTouchDevice ?
                <InputTopWithButtons onSubmit={onSubmitHandler} onClick={onClick} onChange={onChangeHandler} previousAnswers={previousAnswers} />
                :
                <motion.form
                    onSubmit={onSubmitHandler}
                    onClick={onClick}
                    spellCheck={false}
                    className={classes.formcontainer}
                    style={{ pointerEvents: canPassQuestion ? "auto" : "none" }}
                    initial={{ opacity: 0, y: "100%" }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: 0.6 }}
                >
                    <label className={classes.wrapper}>
                        {maxwidthMediaQuery ?
                            <IframeInput
                                onChangeHandler={onChangeHandler}
                                inputValue={inputValue}
                                inputDisabled={inputDisabled}
                                isInputEmpty={isInputEmpty}
                                soundInputHandler={soundInputHandler}
                            />
                            :
                            <NormalInput
                                onChangeHandler={onChangeHandler}
                                inputValue={inputValue}
                                inputDisabled={inputDisabled}
                                isInputEmpty={isInputEmpty}
                                soundInputHandler={soundInputHandler}
                            />
                        }
                    </label>
                </motion.form>
            }
        </>
    )
}